import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, NgZone,
  OnInit, OnDestroy, ViewChild,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Subscription ,  Observable ,  BehaviorSubject, of } from 'rxjs';





import * as _ from 'lodash';


import { BrandService } from '../brand/brand.service';
import { ProcessService } from '../process/process.service';
import { ScrollToService } from '../base/scroll-to.service';
import { SearchPageService } from './search-page.service';
import { AppRoutingService } from '../../app-routing.service';
import { ListManagerService } from '../list-manager/list-manager.service';
import { PermissionsService } from '../permissions/permissions.service';
import { SavedSearchesService } from '../saved-searches/saved-searches.service';
import { UserService } from '../user/user.service';
import { User } from '../user/user';

import { ConfirmStatusChangeItemModel } from '../product/confirm-status-changes/confirm-status-change-item.model';
import { ConfirmStatusChangeResponseModel } from '../product/confirm-status-changes/confirm-status-change-response.model';

import { DefaultModalComponent } from '../modal/default-modal/default-modal.component';
import { CreateNewProductModalComponent } from '../modal/create-new-product-modal/create-new-product-modal.component';
import {
  CreateProductCopyModalComponent
} from 'shared/modal/create-product-copy-modal/create-product-copy-modal.component';
import { ListManagerComponent } from '../list-manager/list-manager.component';
import { LoaderComponent } from '../loader/loader.component';
import { ColumnBuilderModalComponent } from '../column-builder/column-builder-modal/column-builder-modal.component';
import { ColumnsUpdateWarningModalComponent } from '../column-builder/columns-update-warning-modal/columns-update-warning-modal.component';
import { WarningModalComponent } from '../modal/warning-modal/warning-modal.component';
import { ErrorModalComponent } from '../modal/error-modal/error-modal.component';
import { SearchWidgetComponent } from '../search-widget/search-widget.component';
import { SearchFormComponent } from '../search/search-form/search-form.component';
import { BaseAdvancedSearchComponent } from '../search/advanced-search/_base-advanced-search.component';
import { ProcessingModalComponent } from 'shared/modal/processing-modal/processing-modal.component';

import { SearchService } from '../search/search.service';
import { SearchModel } from '../search/search.model';
import { SortModel } from '../search/sort.model';
import { StatusModel } from '../search/status.model';
import { ActiveFilterModel } from '../search/active-filters/active-filter.model';
import {
  VEHICLE_FILTER_TYPE, LIST_FILTER_TYPE, VCDB_FILTER_TYPE, SIMPLE_FILTER_TYPE,
  PART_ATTRIBUTES_FILTER_TYPE, PADB_FILTER_TYPE, CUSTOM_FILTER_TYPE
} from '../search/active-filters/active-filter-types';
import { MAKE_TYPE, MODEL_TYPE, YEAR_START_TYPE, REGION_TYPE, VEHICLE_TYPE
} from '../search/advanced-search/filter-types';
import { QueueProcess } from 'shared/process/queue-process.model';
import { getRandomInt } from 'utils/utils';
import {debounceTime, elementAt, first, skipWhile, takeWhile} from 'rxjs/operators';
import {fromEvent} from 'rxjs/internal/observable/fromEvent';
import { CommentIconComponent } from 'shared/alerts/comment-icon/comment-icon.component';


@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchPageComponent extends SearchWidgetComponent implements OnInit, OnDestroy {

  @ViewChild(DefaultModalComponent, {static: false}) modal: any;

  @ViewChild(CreateNewProductModalComponent, {static: false})
  createNewProductModal: CreateNewProductModalComponent;

  @ViewChild(CreateProductCopyModalComponent, {static: false})
  createProductCopyModal: CreateProductCopyModalComponent;

  @ViewChild(ListManagerComponent, {static: false}) listManager: ListManagerComponent;

  @ViewChild('loader', {static: false}) loader: LoaderComponent;

  @ViewChild(BaseAdvancedSearchComponent, {static: false})
  advancedSearchComponent: BaseAdvancedSearchComponent;

  @ViewChild('header', {static: false}) headerEl: any;

  @ViewChild(ColumnBuilderModalComponent, {static: false})
  columnBuilder: ColumnBuilderModalComponent;

  @ViewChild(ColumnsUpdateWarningModalComponent, {static: false})
  columnsUpdateWarning: ColumnsUpdateWarningModalComponent;

  @ViewChild('builderWarning', {static: false})
  builderWarningModal: WarningModalComponent;

  @ViewChild(ErrorModalComponent, {static: false})
  errorModal: ErrorModalComponent;

  @ViewChild(ProcessingModalComponent, {static: false})
  processingModal: ProcessingModalComponent;

  @ViewChild(CommentIconComponent, {static: false})
  commentIcon: CommentIconComponent | void;

  confirmStatuses: Array<ConfirmStatusChangeItemModel> = [];

  uiModel: any = {};
  actionData: any;
  contentSelector: string = '';
  listsData: Array<any>;
  showLists: boolean = false;
  detailsPageRootRoute: string;
  isScroll: boolean = true;
  showAdvancedSearchVar: boolean = false;
  headerBigHeight: number;
  searchResultsOffset: number;
  isPageActive: boolean = true;
  toggleFromSub: Subscription;
  notificationsSub: Subscription;
  isHeaderFixedSubj = new BehaviorSubject<boolean>(false);
  searchRanSubj = new BehaviorSubject<any>({});
  fieldNames: Array<any> = []; // all possible column builder data
  groupedColumns: Array<any> = []; // list with columns which can contain columns
  selectedColumns: any; // store here selected columns after showing warning modal
  defaultColData: any = {
    sortable: true,
    sort: 'desc',
    active: false,
    colSize: 4,
  };
  isSearchModelReady: boolean = false;
  user: User = null;
  maxColumnsInSearch: number = 10;
  errorModalTitle: string = '';
  panelModalComponentIsShown: boolean = false;
  isSearchRunning: boolean = false;
  showEmptyResultsState: boolean = false;
  handleSearchModelBeforeSearchSubj = new BehaviorSubject<boolean>(false);
  activeQueueProcesses: Array<QueueProcess> = [];

  constructor(
    public searchService: SearchService,
    protected brandService: BrandService,
    protected pageService: SearchPageService,
    protected processService: ProcessService,
    protected scrollToService: ScrollToService,
    protected appRoutingService: AppRoutingService,
    protected listsService: ListManagerService,
    protected permissionsService: PermissionsService,
    protected ngZone: NgZone,
    protected ref: ChangeDetectorRef,
    protected route: ActivatedRoute,
    protected location: Location,
    protected savedSearchesService: SavedSearchesService,
    protected router: Router,
    protected userService: UserService,
  ) {
    super(
      brandService,
      searchService,
    );
    this.subscribeWindowScroll();
  }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngOnInit() {

    this.userService.getUser()
      .subscribe((user) => {
        this.user = user;
        const clearSavedSearchModel = !!_.get(this.route.snapshot.queryParams, 'csm');

        if (_.has(this.route.snapshot.queryParams, 'sid') && !clearSavedSearchModel) {
          this.savedSearchesService.fetch(this.route.snapshot.queryParams.sid)
            .subscribe((res) => {
              if (res.search_model) {
                /*
                  Check to make sure the user is on the brand that is associated with the search.
                 */
                if (_.toNumber(res.brand_relationship_id) !== _.toNumber(this.brandService.getBrand())) {
                  /*
                    If the user is not on the search model brand, then get the brand list
                    to make sure the user has access to the brand associated with the
                    search model.
                   */
                  this.brandService.getBrandList()
                    .subscribe((brands) => {
                        const brand = _.find(brands, {id: _.toNumber(res.brand_relationship_id)});
                        if (brand) {
                          this.brandService.changeSelectedBrand(brand);
                          this.searchModel = res.search_model;
                          this.resetSearchValue();
                          this.searchResultsColumns = res.columns;

                          if (_.hasIn(this, 'storeColumns')) {
                            (<any>this).storeColumns(this.searchResultsColumns);
                          }
                          if (_.hasIn(this, 'addColumnsByRoute')) {
                            (<any>this).addColumnsByRoute(res.search_model.route);
                          }
                          this.isSearchModelReady = true;
                          this.searchModel.selectAll = null;
                          this.handleSearchModelBeforeSearchSubj
                            .pipe(takeWhile(() => this.isPageActive))
                            .subscribe(() => {
                              this._searchModel.next(this.searchModel);
                            });
                          this.handleSearchModelBeforeSearch();
                        } else {
                          this.router.navigate(['/logout']);
                        }
                    });
                  } else {
                    this.searchModel = res.search_model;
                    this.resetSearchValue();
                    if (res.columns && res.columns.length > 0) {
                      this.searchResultsColumns = res.columns;
                    }

                    if (_.hasIn(this, 'sanitizeColumns')) {
                      (<any>this).sanitizeColumns(res.columns);
                    }

                    if (_.hasIn(this, 'storeColumns')) {
                      (<any>this).storeColumns(this.searchResultsColumns);
                    }

                    if (_.hasIn(this, 'addColumnsByRoute')) {
                      (<any>this).addColumnsByRoute(res.search_model.route);
                    }

                    // columns are saved without 'data' field,
                    // to handle it correctly - add 'data' field after
                    // you've got new columns
                    if (_.hasIn(this, 'addDataToColumns')) {
                      (<any>this).addDataToColumns(res.columns);
                    }

                    this.isSearchModelReady = true;
                    this.searchModel.selectAll = null;
                    this.handleSearchModelBeforeSearchSubj
                      .pipe(takeWhile(() => this.isPageActive))
                      .subscribe(() => {
                        this._searchModel.next(this.searchModel);
                      });
                    this.handleSearchModelBeforeSearch();
                  }
              } else {
                this.searchModel = new SearchModel();
                this.searchModel.route = this.route.snapshot.params['page'];
                this.isSearchModelReady = true;
                this.resetSearchValue();
              }
            });

        } else if (_.has(this.route.snapshot.queryParams, 'sm') && !clearSavedSearchModel) {
          try {
            this.searchModel = JSON.parse(this.route.snapshot.queryParams.sm);
            if (_.hasIn(this, 'updateSaveSuffix')) { (<any>this).updateSaveSuffix(); }
            this.storeSearchModel(this.searchModel);
          } catch (e) {
            this.searchModel = new SearchModel();
          }
          this.isSearchModelReady = true;
          this.searchModel.selectAll = null;
          this.resetSearchValue();
        } else if (this.storedSearchModel && !clearSavedSearchModel) {
          this.searchModel = this.storedSearchModel;
          this.searchModel.selectAll = null;
          this.isSearchModelReady = true;
          this.resetSearchValue();
        } else {
          this.searchModel = new SearchModel();
          this.searchModel.route = this.route.snapshot.params['page'];
          this.isSearchModelReady = true;
          this.resetSearchValue();
        }
      });
      if (!this.searchModel) { this.searchModel = new SearchModel(); }


      if ((<any>this).initPage) { (<any>this).initPage(); }
      this.initSubscriptions();

      this.scrollToStoredPosition();
      this.uiModel = this.pageService.uiModel;
      if (this.isScroll) {
        this.scrollToService.init({pageScrollDuration: 200});
      }
      this.fetchLists();
      this.ref.markForCheck();
  }

  ngOnDestroy() {
    this.isPageActive = false;
    this.searchService.searchResults = [];
    this.searchService.selectAllChecked = [];
    this.searchService.selectedItems = [];
    this.searchService.allSelected = false;
    if (this.advancedSearch) { this.advancedSearch.resetAllData(); }
    this.searchModel.filters = [];
    this.searchModel.selectAll = null;
    this.searchResultsColumns = [];
    this.destroySubscriptions();
  }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

   get advancedSearch(): any {
     if (this.advancedSearchComponent) {
       return this.advancedSearchComponent;
     }
     const headerAdvancedSearch = _.get(this.headerEl, 'advancedSearchComponent');
     if (headerAdvancedSearch) { return headerAdvancedSearch; }
     return null;
   }

   get showAdvancedSearch(): boolean {
     const hasHeaderShowAdvancedSearch = _.has(this.headerEl, 'searchComponent.showAdvancedSearch');

     if (hasHeaderShowAdvancedSearch) {
       return _.get(this.headerEl, 'searchComponent.showAdvancedSearch');
     }

     return this.showAdvancedSearchVar;
   }

  get typeAheadValue(): any {
    if (_.get(this, 'searchForm.typeAheadValue')) {
      return this.searchForm.typeAheadValue;
    } else {
      return _.get(this, 'headerEl.searchComponent.typeAheadValue');
    }
  }

   get disableItemSelect(): boolean {
     return (this.searchModel.selectAll === 'in-list');
   }

   get statuses(): Array<any> {
     return this.searchService.statuses;
   }

   get listId(): string {
     return this.searchService.listFilterId;
   }

   get currentStatusModel(): StatusModel {
     return this.searchModel.statusModel;
   }

   get currentStatusModelId(): number|undefined {
     return _.get(this.currentStatusModel, 'id');
   }

   get searchModelListFilters(): Array<any> {
     return _.filter(this.searchModelFilters, (filter: any) => {
       return filter.type === LIST_FILTER_TYPE;
     });
   }

   get searchModelVcdbFilters(): Array<any> {
     return _.filter(this.searchModelFilters, (filter: any) => {
       return filter.type === VCDB_FILTER_TYPE;
     });
   }

   get searchModelVehicleFilters(): Array<any> {
     return _.filter(this.searchModelFilters, (filter: any) => {
       return filter.type === VEHICLE_FILTER_TYPE;
     });
   }

   get searchModelPartAttrFilters(): Array<any> {
     return _.filter(this.searchModelFilters, (filter: any) => {
       return filter.type === PART_ATTRIBUTES_FILTER_TYPE;
     });
   }

   get availableStatuses(): Array<any> {
      if (!this.allSelected) {
        return _.uniq(_.map(this.selectedRows, 'status'));
      } else {
        return _.map(_.filter(this.statuses, (status) => {
          return (status.statusAmount > 0);
        }), 'id');
     }
   }

   get storedSearchModel(): SearchModel | null {
     return null;
   }

   get headerColor(): string {
     return 'red';
   }

   get advancedSearchStatus(): string {
     return 'working';
   }

   get isEmptyState(): boolean {
     return (!this.searchResults.length && !this.isSearchRunning && this.showEmptyResultsState);
   }

  get searchInputValue(): string {
     // handle it in the components
     // to get search value from header search input
     return null;
  }

  // redefine it to disable search run on certain page
  get allowSearchRun(): boolean {
    return true;
  }

   /*******************************************
    * COMPONENT SETTERS
    *******************************************/

   set showAdvancedSearch(show: boolean) {
     const hasHeaderShowAdvancedSearch = _.has(this.headerEl, 'searchComponent.showAdvancedSearch');

     if (hasHeaderShowAdvancedSearch) {
       _.set(this.headerEl, 'searchComponent.showAdvancedSearch', show);
     } else {
       this.showAdvancedSearchVar = show;
     }
   }

  /*******************************************
   * COMPONENT EVENT HANDLERS
   *******************************************/

   onActionSelected(action: any) {
    switch (action.action) {
      case 'ADD_TO_LIST':
        this.listManager.addToList();
        break;
      case 'REMOVE_FROM_LIST':
        this.removeFromListRequest()
        .subscribe((res) => {
            if (res.processId) {
                const process: QueueProcess = new QueueProcess(res.processId, 0);
                this.startProcessingModal(process);
            } else {
              this.fetchLists();
              this.runSearch(this.searchModel);
              this.searchService.clearSelectedItems();
            }

        });
        break;
      case 'BULK_EDIT':
        this.panelModalComponentIsShown = true;
        _.defer(() => this.handleBulkEdit());
        break;
      case 'VIEW_DETAILS':
        this.handleViewDetails();
        break;
      default:
        if (this.totalRowsSelected || this.allSelected) {
          const statusCounts = this.searchService.getSelectedStatusCounts();
          this.confirmStatuses = [];

          _.forEach(statusCounts, (statusCount) => {
            const statusChangeItem = new ConfirmStatusChangeItemModel();
            statusChangeItem.count = statusCount.count;
            if (action.type === 'import-apps1') {
              statusChangeItem.from = 'Imported';
              statusChangeItem.to = 'Accepted';
            } else {
              statusChangeItem.from = this.searchService.getStatusName(parseInt(statusCount.statusId));

              if ( action.meta.statusId === parseInt(statusCount.statusId) ) {
                statusChangeItem.to = 'Unchanged';
              } else {
                statusChangeItem.to = this.searchService.getStatusName(action.meta.statusId);
              }
            }
            this.confirmStatuses.push(statusChangeItem);
         });

        this.actionData = action;
        this.modal.show();
      }
      break;
    }
  }

  onPageChange(page: number) {
    this.searchModel.currentPage = page;
    if (this.isScroll) {
      this.scrollToService.scrollTo({
        scrollTarget: this.contentSelector,
        pageScrollFinish: this._searchModel.next(this.searchModel),
      });
    }
  }

  onStatusSelected(status: string) {
    this.searchModel.currentPage = 1;
    // @ts-ignore
      this.searchModel.statusModel = _.find(this.statuses, {name: status});
    this._searchModel.next(this.searchModel);
  }

  onSearchPreviewClick() {
    this.searchService.toggleForm(true);
  }

  onDetailsBtnClick(itemId: string) {
    console.log('Route to item detail page');
  }

  onFilterRemove(filter: ActiveFilterModel) {
    switch (filter.type) {
      case LIST_FILTER_TYPE:
        if (this.listManager) { this.listManager.unselectList(filter._id); }
        break;
      default:
        break;
    }
    this.deselectAll();
    super.onFilterRemove(filter);
    this.showEmptyResultsState = false;
  }

  onClearSearchClick() {
    this.showEmptyResultsState = false;
    if (this.listManager) { this.listManager.resetSelectedLists(); }
    this.deselectAll();
    super.onClearSearchClick();
    this.resetSearchValue();
  }

  onAdvancedSearchToggle() {
    this.showAdvancedSearch = !this.showAdvancedSearch;
  }

  onAdvancedSearchOpen() {
    this.toggleAdvancedSearch(true);
  }

  onCancelAdvancedSearchClick() {
    this.toggleAdvancedSearch(false);
  }

  onAdvancedSearchRun() {
    if (this.showAdvancedSearch) {
      this.applyAdvancedSearchFilters();
    }
    if (this.searchModel.filters) {
      // check header height (filters could strech header height)
      _.defer(() => {
        if (this.headerEl && _.get(this.headerEl, 'nativeElement.offsetHeight')) {
          this.headerBigHeight = this.headerEl.nativeElement.offsetHeight;
          this.setSearchResultsOffset(this.headerBigHeight);
        }
      });
    }
    // deselect all selected rows
    if (this.selectAll === 'in-list' || this.selectedRows.length) {
      this.deselectAll();
    }
    this.toggleAdvancedSearch(false);
    if (!_.isNil(this.searchInputValue)) {
      this.searchModel.searchValue = this.searchInputValue;
    } else if (this.searchForm) {
      this.searchModel.searchValue = this.searchForm.searchTermValue;
    }
    this._searchModel.next(this.searchModel);
  }

  onAdvancedFiltersClear() {
    this.searchModel.searchValue = '';
    this.resetSearchValue();
    _.remove(this.searchModelFilters, ['type', VCDB_FILTER_TYPE]);
    this._searchModel.next(this.searchModel);
  }

  // lists events handlers

  onConfirmListChanges(data: Array<any>) {
    // if list was removed, remove filter from searchModel
    const filter = _.find(this.searchModel.filters, (_filter: ActiveFilterModel) => {
      if (_filter.type !== LIST_FILTER_TYPE) { return false; }
      return !_.includes(data, ['_id', _filter._id]);
    });
    if (filter) {
      _.remove(this.searchModel.filters, filter);
      this._searchModel.next(this.searchModel);
    }
  }

  onAddToListComplete(selectedLists: Array<any>) {
    this.addToListRequest(selectedLists)
    .pipe(first())
    .subscribe((res: any) => {
      this.showLists = false;
      this.searchService.deselectAll();
      this.searchModel.selectAll = 'on-page';
      if (res.processId) {
        const process: QueueProcess = new QueueProcess(res.processId, 0);
        this.startProcessingModal(process);
      } else {
        if (this.searchModelListFilters.length) {
          this._searchModel.next(this.searchModel);
        }
        this.fetchLists();
      }
    });
  }

  onAddToListCancel() {
    this.showLists = false;
  }

  onListSelect(selectedList: any) {
    // change list filter
    _.remove(this.searchModel.filters, (filter: ActiveFilterModel) => {
      return filter.type === LIST_FILTER_TYPE;
    });
    this.deselectAll();
    if (selectedList.selected) {
      const filter = new ActiveFilterModel(
        selectedList._id,
        selectedList.name,
        LIST_FILTER_TYPE
      );
      this.searchModel.currentPage = 1;
      // this.searchModel.filters.push(filter);
      // insert list filter first
      this.searchModel.filters = [filter, ...this.searchModel.filters];
    }
    this._searchModel.next(this.searchModel);
    this.showEmptyResultsState = false;
  }

  onListIconClick() {
    this.showLists = !this.showLists;
  }

  onPanelModalHide() {
    this.runSearch(this.searchModel);
    _.defer(() => this.panelModalComponentIsShown = false);
  }

  onPageActionSelect($event: any) {
    switch ($event.action) {
      case 'edit-columns':
        this.showColumnBuilder();
        break;
      default:
        this.handlePageAction($event.action);
        break;
    }
  }

  // column builder
  onConfirmBuilderWarning(notShowAgain: any) {
    if (notShowAgain) {
      if (_.has(this, 'user.id')) {
        localStorage.setItem(`notShowColumnsWarn.${this.user.id}`, 'true');
      }
    }
    _.delay(() => this.columnBuilder.show(), 1000);
  }

  onColumnsSave(selectedColumns: Array<any>) {
    if (_.has(this, 'user.id') && localStorage.getItem(`notShowColumnsUpdateWarn.${this.user.id}`)) {
      this.changeColumns(selectedColumns);
    } else {
      _.delay(() => {
        this.selectedColumns = selectedColumns;
        this.ref.markForCheck();
        this.columnsUpdateWarning.show();
      }, 1000);
    }
  }

  onColumnsUpdateConfirm(notShowAgain: boolean) {
    if (notShowAgain) {
      if (_.has(this, 'user.id')) {
        localStorage.setItem(`notShowColumnsUpdateWarn.${this.user.id}`, 'true');
      }
    }
    this.changeColumns(this.selectedColumns);
  }

  onAdjustSearchClick() {
    this.toggleAdvancedSearch(true);
  }

  /*******************************************
   * COMPONENT METHODS
   *******************************************/
  showActionPanel() {
    return this.searchService.allSelected || this.searchService.selectedItems.length > 0;
  }

  handleConfirmStatusAction($event: ConfirmStatusChangeResponseModel) {
    if ($event.action === 'confirmed') {
      this.handleAction($event.data);
    }
    this.modal.hide();
  }

  initSubscriptions() {
    this.searchModelSub = this.subscribeSearchModel();
    this.toggleFromSub = this.subscribeToggleForm();
    this.isHeaderFixedSubj
    .pipe(takeWhile(() => this.isPageActive))
    .subscribe((val: boolean) => {
      if (this.uiModel.isHeaderFixed === val) { return; }
      this.pageService.uiModel.isHeaderFixed = val;
      this.pageService.uiModel.isSortingCollapsed = val;
      if (val) {
        this.setSearchResultsOffset(this.uiModel.headerMinHeight);
      } else {
        this.setSearchResultsOffset(this.headerBigHeight);
      }
      this.ref.markForCheck();
    });
  }

  destroySubscriptions() {
    if (this.toggleFromSub) {     this.toggleFromSub.unsubscribe(); }
    if (this.searchModelSub) {    this.searchModelSub.unsubscribe(); }
    if (this.notificationsSub) {  this.notificationsSub.unsubscribe(); }
  }

  // scroll to stored position after getting back from product details page
  scrollToStoredPosition() {
    this.searchService.searchResultsSubject
    .pipe(
        elementAt(1),
        takeWhile(() => this.isPageActive)
    )
    .subscribe((res: Array<any>) => {
      _.delay(() => {
        document.body.scrollTop = +localStorage.getItem('scrollTop');
      }, 0);
    });
  }

  subscribeSearchModel(): Subscription {
    this._searchModel = <BehaviorSubject<SearchModel>>new BehaviorSubject(this.searchModel);
    this.searchModelObservable = this._searchModel.asObservable();

    return this.searchModelObservable
      .pipe(debounceTime(900), skipWhile(() => !this.isSearchModelReady))
      .subscribe((searchModel) => {
        this.rewriteUrl(searchModel, this.searchResultsColumns);
        this.storeSearchModel(searchModel);
        this.runSearch(searchModel);
      });
  }

  subscribeToggleForm(): Subscription {
    return this.searchService.toggleFormEvent
      .subscribe((toggle: boolean) => {
        this.pageService.uiModel.isSearchFormOpened = toggle;
      });
  }

  runSearch(searchModel: SearchModel) {
    if (!this.allowSearchRun) {
      return;
    }
    this.startLoading();
    this.searchService.runSearch(this.brandService.getBrand(), searchModel)
    .pipe(first())
    .subscribe(searchResults => {
      if (!this.isPageActive) { return; }
      if (_.has(this.searchModel, 'statusModel.id')) {
        // @ts-ignore
          this.searchModel.statusModel = _.find(this.statuses, {id: this.searchModel.statusModel.id});
      }
      this.searchRanSubj.next(searchResults);
    }, null, () => this.stopLoading());
  }

  handleAction(action: any) {
    console.log(`Action: ${action.type}`);
  }

  storeSearchModel(searchModel: SearchModel) {
    console.log('storeSeachModel not implemented');
  }

  fetchLists() {
    if (!this.listsService) { return; }
    this.listsService.fetch()
    .subscribe((data: any) => {
      const listFilter = _.find(this.searchModel && this.searchModel.filters || [], (filter: ActiveFilterModel) => {
        return filter.type === LIST_FILTER_TYPE;
      });
      if (listFilter) {
        listFilter.selected = true;
        this.listManager.selectedList = listFilter;
      }
      this.listsData = data;
      this.ref.markForCheck();
    });
  }

  handleBulkEdit() {
    console.warn('handleBulkEdit method is not implemented!');
  }

  handleViewDetails() {
    console.warn('handleViewDetails method is not implemented!');
  }

  handleSearchModelBeforeSearch() {
    this.handleSearchModelBeforeSearchSubj.next(true);
  }

  startLoading() {
    this.loader.show();
    this.ref.markForCheck();
    this.isSearchRunning = true;
    if (!this.showEmptyResultsState) { this.showEmptyResultsState = true; }
  }

  stopLoading() {
    _.delay(() => {
      this.isSearchRunning = false;
      this.loader.hide();
      this.ref.markForCheck();
    }, 500);
  }

  setSearchResultsOffset(value?: number) {
    this.searchResultsOffset = value;
  }

  hasPermission(allow: Array<string>|string, requireAll: boolean= false) {
    return this.permissionsService.hasPermission(allow, requireAll);
  }

  toggleAdvancedSearch(toggle: boolean): void {
    this.showAdvancedSearch = toggle;
    this.searchService.toggleForm(toggle);
  }

  addToListRequest(selectedLists: any): Observable<any> {
    if (!this.listsService) { return of(null); }
    return this.listsService.addToLists(
      this.selectedRowsIds,
      selectedLists
    );
  }

  removeFromListRequest(): Observable<any> {
    if (!this.listsService) { return of(null); }
    return this.listsService.removeFromList(
      this.selectedRowsIds,
      this.listManager.selectedList._id
    );
  }

  subscribeWindowScroll(): void {
    this.ngZone.runOutsideAngular(() => {
      fromEvent(window, 'scroll')
      .pipe(takeWhile(() => this.isPageActive))
      .subscribe((e: any) => {
        if (this.pageService.isScrollingProhibited) { return; }
        if (window.pageYOffset > 10) {
          if (!this.pageService.uiModel.isHeaderFixed) {
            this.isHeaderFixedSubj.next(true);
          }
        } else {
          if (this.pageService.uiModel.isHeaderFixed) {
            this.isHeaderFixedSubj.next(false);
          }
        }
      });
    });
  }

  rewriteUrl(searchModel: SearchModel, columns: Array<{}>) {
    let route = this.getCurrentRouteUrl();
    const queryParams = _.omit(this.route.snapshot.queryParams, ['sid', 'sm', 'sc', 'smlocal']);

    const queryString: Array<string> = [];

    // @ts-ignore
      _.mapKeys(queryParams, (value, key) => {
      queryString.push(`${key}=${encodeURIComponent(value)}`);
    });

    this.savedSearchesService.postSavedSearch(this.brandService.getBrand(), searchModel, columns)
      .subscribe((res) => {
        if (res.id) {
          queryString.push(`sid=${encodeURIComponent(res.id)}`);
          if (queryString.length) {  route = `${route}?${queryString.join('&')}`; }
          this.location.go(route);
        } else {
          this.handleSearchError();
        }
      });

  }

  getCurrentRouteUrl(): string {
    return `/${this.route.snapshot.url.join('/')}`;
  }

  /*
    * Get selected filters from advanced search
    * Set them to searchModel.filters<Array<ActiveFilterModel>>
  */
  applyAdvancedSearchFilters(): void {
    // get active filters except multiple & partAttributes to avoid duplicates
    const advSearchActiveFilters = _.filter(this.advancedSearch && this.advancedSearch.activeFilters || [], (filter: ActiveFilterModel) => {
      return !_.get(filter, 'data.multiple') &&
        filter.type !== PART_ATTRIBUTES_FILTER_TYPE &&
        filter.type !== VCDB_FILTER_TYPE &&
        filter.type !== PADB_FILTER_TYPE &&
        filter.type !== CUSTOM_FILTER_TYPE;
    });

    const vehicleFilters = this.advancedSearch.vehicleFilters;
    const partAttributeFilters = this.advancedSearch.partAttributes;
    const vcdbFilters = this.advancedSearch.selectedVcdbFilters;
    const filters = _.chain([])
      .concat(advSearchActiveFilters, vehicleFilters, partAttributeFilters, vcdbFilters)
      .compact()
      .value();

      // remove current search filters related to advanced search
    _.remove(this.searchModel.filters, (filter: ActiveFilterModel) => {
      return !_.includes([LIST_FILTER_TYPE, SIMPLE_FILTER_TYPE], filter.type);
    });

    // add new search filters from advanced search
    this.searchModel.filters = _.concat(this.searchModel.filters, filters);
  }

  /*
    * Method for local page actions handling
  */
  handlePageAction(action: string) {
    console.log('Method handlePageAction is not inherited');
  }

  deselectAll() {
    this.searchService.deselectAll();
    this.searchModel.selectAll = 'on-page';
  }

  showColumnBuilder(): void {
    if (_.has(this, 'user.id') && localStorage.getItem(`notShowColumnsWarn.${this.user.id}`)) {
      this.columnBuilder.show();
    } else {
      this.builderWarningModal.show();
    }
  }

  /*
    ****** Column methods ******
  */

  /*
    * Column builder method for changing columns
  */
  changeColumns(selectedColumns: Array<any>): void {
    // create new columns
    const newColumns: Array<any> = this.createNewColumns(selectedColumns);
    // set new columns
    this.searchResultsColumns = newColumns;
    // add column names to search model (used in the search query)
    this.searchModel.columns = _.chain(newColumns).tail().map('columnName').value();
    if (_.hasIn(this, 'storeColumns')) {
      (<any>this).storeColumns(this.searchResultsColumns);
      this.rewriteUrl(this.searchModel, this.searchResultsColumns);
    }
    this.selectedColumns = null;
    this.ref.markForCheck();
  }

  createNewColumns(selectedColumns: any): Array<any> {
    const newColumns: Array<any> = _.reduce(selectedColumns, (result: Array<any>, item: any) => {
      // find column in current columns
      let column: any = _.find(this.searchResultsColumns, ['columnName', item.option]);
      if (!column) {
        // check if column contains nested column
        column = _.find(this.groupedColumns, ['option', item.option]);
        if (column) {
          // create column for every columnName in the group
          _.each(column.attributes, (columnName: string) => {
            // check if nested column has already existed in the current columns
            let nestedColumn = _.find(this.searchResultsColumns, ['columnName', columnName]);
            if (!nestedColumn) {
              // otherwise create column data
              const attributeData = _.find(this.fieldNames, ['column_name', columnName]);
              nestedColumn = this.createColumnFromLookup(attributeData);
            }
            result.push(nestedColumn);
          });
        } else {
          column = this.createColumnFromLookup(item, item.colSize);
          result.push(column);
        }
      } else {
        result.push(column);
      }
      return result;
    }, [this.searchResultsColumns[0]]);
    // calculate columns size (if columns more than 9 then reduce column size)
    const colSize: number = this.getColumnSize(newColumns);
    if (colSize !== this.defaultColData.colSize) {
      _.each(newColumns, (item: any) => item.colSize = colSize);
    }
    return newColumns;
  }

  /*
    * Calculate size for every column
  */
  getColumnSize(columns: Array<any>): number {
    return columns.length > 9 ? Math.floor(35 / columns.length) : this.defaultColData.colSize;
  }

   /*
    * Create column data from the lookup options
    * (after changing columns by column builder)
  */
  createColumnFromLookup(item: any, colSize?: number): any {
    return Object.assign(
      item,
      this.createColumn(item.title_column_name, item.option, item.title, colSize, item.sortable)
    );
  }

  /*
    * Create general column data
  */
  createColumn(title: string, col: string, tooltipTitle: string, colSize: number = 4, sortable: boolean = true): any {
    return Object.assign({}, this.defaultColData, {
      title,
      colSize,
      sortName: col,
      col: _.snakeCase(col),
      columnName: col,
      tooltipTitle,
      sortable: _.isNil(sortable) ? true : sortable,
    });
  }

  /*
    * Remove all active columns
  */
  removeAllActiveColumns(): void {
    this.searchResultsColumns = this.getDefaultColumns();
    this.searchModel.columns = [];
    this.searchModel.sortModel = null;
  }

  getDefaultColumns(): any {
    return console.warn('getDefaultColumns not implemented');
  }

  resetSearchValue() {
    if (this.searchForm) {
      this.searchForm.resetValue(this.searchModel.searchValue);
    } else if (_.get(this.headerEl, 'resetSearchValue')) {
      this.headerEl.resetSearchValue(this.searchModel.searchValue);
    }
  }

  detectQueueProcessProgress(queueProcess: QueueProcess): void {
    _.delay(() => {
      console.log(queueProcess);
      this.processService.getQueueProcess(this.brandService.getBrand(), queueProcess.id)
      .pipe(takeWhile(() => this.isPageActive))
      .subscribe((process: any) => {
        if (!this.isPageActive) { return; }
        queueProcess.progress = process.progress;
        this.ref.markForCheck();
        if (process.progress < 100) {
          this.detectQueueProcessProgress(queueProcess);
        } else {
          _.pull(this.activeQueueProcesses, queueProcess);
          if (!_.size(this.activeQueueProcesses)) {
            this.processingModal.hide();
            this.handleCompleteQueueProcess(queueProcess);
          }
        }
      });
    }, getRandomInt(500, 2500));
  }

  startProcessingModal(process: QueueProcess): void {
    this.activeQueueProcesses.push(process);
    if (this.commentIcon) {
      this.commentIcon.showAndHide();
    }
    this.detectQueueProcessProgress(process);
  }

  handleCompleteQueueProcess(queueProcess: QueueProcess): void {
    this.runSearch(this.searchModel);
    this.fetchLists();
  }

  handleSearchError() {
    this.errorModalTitle = 'Something went wrong with the search. Please refresh the page to keep going';
    if (this.errorModal) {
      this.errorModal.show();
    }
  }
}
